(function() {
    var m = angular.module('onlinecon', []);

    m.controller('OnlineConsultationsCtrl', ['$scope', function($scope) {
        $scope.items = ONLINE_CONSULTATIONS;
    }]);
})();
